function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.654 1.81192C12.0373 1.05114 13.5921 0.656891 15.1708 0.666682C15.5373 0.668956 15.8333 0.96676 15.8333 1.33334C15.8333 3.20687 15.3077 6.47181 11.9317 8.94443C11.9885 9.1828 12.0531 9.49657 12.0978 9.84328C12.1466 10.2215 12.174 10.6569 12.1342 11.0854C12.0949 11.5081 11.9858 11.9733 11.7213 12.37L11.7207 12.3708C11.2681 13.0475 10.4144 13.4397 9.81813 13.656C9.49768 13.7723 9.20162 13.8547 8.98619 13.9082C8.82382 13.9484 8.70467 13.9729 8.65065 13.9834C8.44518 14.0225 8.23583 13.9814 8.07273 13.8453C7.921 13.7186 7.8333 13.5311 7.8333 13.3335V10.2761L6.224 8.66684H3.16663C2.96898 8.66684 2.78152 8.57914 2.65486 8.42741C2.52819 8.27569 2.47538 8.07558 2.51068 7.88111C2.53317 7.75783 2.56181 7.63552 2.59197 7.51395C2.6454 7.29852 2.72785 7.00246 2.84409 6.68201C3.06039 6.08569 3.45267 5.23203 4.12928 4.7794L4.13016 4.77881C4.52683 4.51437 4.99202 4.40524 5.41473 4.36595C5.84318 4.32613 6.2786 4.35356 6.65685 4.40231C7.00719 4.44746 7.32389 4.51297 7.56316 4.57022C8.3704 3.43089 9.42652 2.48705 10.654 1.81192Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50207 9.99239C3.97996 9.97624 3.47028 10.1534 3.07077 10.4899C2.71958 10.7851 2.46173 11.1917 2.27074 11.5827C2.07595 11.9815 1.92792 12.4118 1.81735 12.7984C1.70617 13.1871 1.62889 13.5456 1.57938 13.8063C1.55454 13.9372 1.53647 14.0445 1.52447 14.1202C1.51796 14.1613 1.51186 14.2025 1.50604 14.2437L1.50589 14.2448C1.47836 14.4507 1.54835 14.6579 1.69524 14.8048C1.84212 14.9517 2.04965 15.0216 2.25555 14.9941C2.29701 14.9882 2.33843 14.9821 2.3798 14.9756C2.45548 14.9636 2.56287 14.9455 2.69371 14.9206C2.95447 14.8711 3.31296 14.7939 3.70165 14.6827C4.08821 14.5721 4.51857 14.4241 4.91736 14.2293C5.30823 14.0384 5.71468 13.7806 6.0098 13.4296C6.69048 12.6235 6.70064 11.3679 5.90837 10.5857L5.90027 10.5778C5.52227 10.217 5.02435 10.0085 4.50207 9.99239Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b1f6dc1262022d538fc5322980f82eea.svg";
export { ForwardRef as ReactComponent };